'use strict';

import React, { Component } from 'react'

import _ from 'lodash'

import { handleChange } from '@/Form/Functions/eventsHandling'
import getFormStatus    from '@/Form/Functions/getFormStatus'

import Form from '@/Form/toolkit/Form'

import AutoCompletedField from '@Pure/AutoCompletedField'
import Collapse           from '@Pure/Collapse'
import Loader             from '@Pure/Loader'

import getFormElement from '@/Form/Functions/getFormElement'

const { app, qwest } = window;

class UpdateForm extends Component
{
	constructor (props)
	{
		super(props);

		this.state =
		{
			form_data: { },
			status_messages: { },
			repeatable_fields: { },
			private_form: { },
			collapses_status: { },
			views: { },
			fetching_view_data: false,
			loading: false,
			readOnly: false
		};

		this.openDeleteModal          = this.openDeleteModal.bind(this);
		this.handleValidate           = this.handleValidate.bind(this);
		this.handleFailure            = this.handleFailure.bind(this);
		this.handleChange             = this.handleChange.bind(this);
		this.handleDeletion           = this.handleDeletion.bind(this);
		this.handlePrivateChange      = this.handlePrivateChange.bind(this);
		this.addViewElement           = this.addViewElement.bind(this);
		this.removeViewItem           = this.removeViewItem.bind(this);
		this.get__Views               = this.get__Views.bind(this);
		this.handleAutocompleteChange = this.handleAutocompleteChange.bind(this);

		this.getFormElement = getFormElement.bind(this);
	}

	UNSAFE_componentWillMount ()
	{
		const component = this, props = this.props, config = this.props.config;
		const state     = this.state;

		let id = document.location.pathname.split('/');

		id = id[id.length-1] ? id[id.length-1] : id[id.length-2];

		id = props.id || id;

		app.push(
		{
			event: 'deletedCMSContent',
			cb: component.handleDeletion
		});

		app.push(
		{
			event: 'autoCompleteChange',
			cb: component.handleAutocompleteChange
		});

		if (config.hookComponentWillMount instanceof Function)
		{
			config.hookComponentWillMount.bind(component)();
		}

		let repeatable_fields = { };

		(config.custom_fields || []).forEach(function (field)
		{
			repeatable_fields[field.name] = { count: 1 };
		});

		(config.repeatable || []).forEach(function (field)
		{
			let name = (field instanceof Object && field.name) ? field.name : field;

			repeatable_fields[name] = { count: 1 };
		});

		let models_requested = [], views = state.views;

		(config.views || []).forEach(function (view)
		{
			views[view.source_field] = { ids: [], data: [] };
		});

		state.form_data.model = config.model;
		state.form_data.id    = id;

		component.setState(
		{
			loading: true,
			form_data:
			{
				...state.form_data
			},
			repeatable_fields: repeatable_fields
		});

		Object.keys(config.fields).forEach(function (field_name)
		{
			let autocomplete_data = [], model, field = config.fields[field_name];

			if (!config.fields[field_name].reference) return;

			model = field.reference.model;

			if (models_requested.indexOf(model) !== -1) return;

			if (!app.state.autocomplete_data[model])
			{
				app.state.autocomplete_data[model] = [];
			}

			if (app.state.autocomplete_data[model].length > 0) return;

			models_requested.push(model);

			qwest.post('/CMS/getForAutocomplete', { model: model })
			.then(function (xhr, response)
			{
				app.state.autocomplete_data[model] = response.data;

				app.emit('autoCompleteChange', { data: response.data, model: model });
			})
			.catch(function (error, xhr, response)
			{
				app.ajaxRedirectLogin(response);

				console.error(error);
			});
		});

		qwest.post('/CMS/get', { id: id, model: config.model })
		.then(function (xhr, response)
		{
			let form_data, private_form, repeatable_fields;

			let data = app.getFormDataFromResponse(
			{
				config: config,
				data: response.data
			});

			form_data = _.merge(state.form_data, _.cloneDeep(data.form_data));

			let views_update = app.getViewIdsFromResponse(
			{
				config: config,
				data: response.data,
				views_state: _.cloneDeep(views)
			});

			repeatable_fields = data.repeatable_fields;

			if (config.hookGetDataAjax instanceof Function)
			{
				config.hookGetDataAjax.bind(component)(form_data, response);
			}

			component.setState(
			{
				loading: false
			});

			Object.keys(views_update).forEach(function (field)
			{
				views[field].ids = views_update[field].ids;

				views[field].ids.forEach(function (id)
				{
					let filter_query =
					{
						id: id
					};

					qwest.post('/CMS/getAll',
					{
						model: config.fields[field].reference.model,
						filter_query: JSON.stringify(filter_query)
					})
					.then(function (xhr, response)
					{
						let form_data = _.cloneDeep(component.state.form_data);

						let data =
						{
							model_data: response.data[0],
							referenced_data: response.references
						};

						views[field].data.push(data);

						views[field].ids.forEach(function (id, index)
						{
							let pattern = config.model;

							field.split('[').join(']').split(']')
							.filter(str => str !== '')
							.forEach(function (prop)
							{
								pattern += '[' + prop + ']';
							});

							pattern += '[' + index + ']';

							form_data[pattern] = id;
						});

						component.setState(
						{
							views: views,
							form_data: form_data
						});
					})
					.catch(function (error, xhr, response)
					{
						app.ajaxRedirectLogin(response);

						console.error(error);
					});
				});
			});

			if (config.readOnly instanceof Function)
			{
				component.setState(
				{
					readOnly: config.readOnly(component.state.readOnly, response.data),
					form_data: form_data,
					repeatable_fields: Object.assign(component.state.repeatable_fields,
						repeatable_fields),
					loading: false
				});
			}
			else
			{
				component.setState(
				{
					form_data: form_data,
					repeatable_fields: Object.assign(component.state.repeatable_fields,
						repeatable_fields),
					loading: false
				});
			}
		})
		.catch(function (error, xhr, response)
		{
			component.setState(
			{
				loading: false
			});

			app.ajaxRedirectLogin(response);

			console.error(error);
		});
	}

	componentWillUnmount ()
	{
		const component = this, props = this.props, config = this.props.config;

		app.delete(
		{
			type: 'listener',
			event: 'deletedCMSContent',
			cb: component.handleDeletion
		});

		app.delete(
		{
			event: 'autoCompleteChange',
			cb: component.handleAutocompleteChange
		});
	}

	handleChange (e, data)
	{
		const component = this, props = this.props, state = this.state;

		handleChange.bind(component)(e, data);

		if (props.config && props.config.hookOnChange instanceof Function)
		{
			props.config.hookOnChange.bind(component)(e, data);
		}
	}

	handleAutocompleteChange ()
	{
		const component = this, props = this.props, config = this.props.config;

		component.render.bind(component)();
	}

	handleDeletion (deleted)
	{
		const component = this, props = this.props, config = this.props.config;

		component.setState(
		{
			deleted: deleted
		});

		if (typeof props.onDelete === 'function')
		{
			props.onDelete();
		}
	}

	openDeleteModal ()
	{
		const component = this, props = this.props, config = this.props.config;

		var id = document.location.pathname.split('/');

		id = id[id.length-1] ? id[id.length-1] : id[id.length-2];

		app.emit('open__DeleteModal',
		{
			id: id,
			model: config.model,
			pattern: config.pattern,
			config: config,
			form_data: component.state.form_data
		});
	}

	handleValidate (response)
	{
		const component = this, props = this.props;

		var form_data       = this.state.form_data;
		var status_messages = Object.assign({ }, this.state.status_messages);

		Object.keys(response.fields || { }).forEach(function (field, index)
		{
			status_messages[field] = response.fields[field];
		});

		Object.keys(response.fields || { }).find(function (field)
		{
			if (response.fields[field] && response.fields[field].info)
			{
				return true;
			}
		});

		if (!response.info)
		{
			response.info = 'Mise à jour réussie.';
		}

		component.setState(
		{
			status_messages: status_messages,
			form_data: form_data,
			error: response.error,
			warning: response.warning,
			info: response.info,
			created: response.created,
			loading: false,
			collapses_status: { }
		});

		if (typeof props.onValidate === 'function')
		{
			props.onValidate(response);
		}
	}

	handleFailure (response)
	{
		const component = this, props = this.props, config = this.props.config;
		const state     = this.state;

		var status_messages = Object.assign({ }, this.state.status_messages);

		Object.keys(response.fields || { }).forEach(function (field, index)
		{
			status_messages[field] = response.fields[field];
		});

		if (response.E_CODE === 'duplicate')
		{
			Object.keys(response.duplicated).forEach(function (field)
			{
				var recomposed_name = config.model + '[' + field + ']';

				if (response.duplicated[field] === state.form_data[recomposed_name])
				{
					status_messages[recomposed_name] =
					{
						error: 'Ce champs est unique et a ' +
							'déjà été utilisé.'
					};
				}
			});
		}

		component.setState(
		{
			status_messages: status_messages,
			error: response.error,

			...(response.errors ? { errors: response.errors } : { }),

			warning: response.warning,
			info: undefined,
			loading: false,
			collapses_status: response.collapses_status || { }
		});
	}

	get__Table (table, key)
	{
		const component = this, props = this.props, config = this.props.config;
		const state     = this.state;

		let row_key = 0;

		let head = Object.keys(table.columns || { })
		.map(function (label, key)
		{
			return <div className="c-form-table__thead-cell" key={ key }>{ label }</div>;
		});

		let rows_number = component.state.repeatable_fields[table.table_name];

		if (typeof rows_number === 'undefined' || rows_number.count < 0)
		{
			rows_number = 0;
		}
		else
		{
			rows_number = rows_number.count;
		}

		let rows = [];

		for (let i = 0; i < rows_number; i++)
		{
			rows.push(getRow(i));
		}

		let title;

		if (table.title)
		{
			title =
			(
				<div className="c-form-table__title">
					{ table.title }
				</div>
			);
		}

		let t_head;

		if (table.break === true)
		{
			let first  = head
				.filter((cell, key) => key+1 <= (head.length / 2 + head.length % 2 ));

			let second = head
				.filter((cell, key) => key+1 > (head.length / 2 + head.length % 2));

			if (first.length > second.length)
			{
				second.push(
					<div className="c-form-table__thead-cell"
						key={ first.length + second.length }></div>
				);
			}

			t_head =
			[
				<div className="c-form-table__thead first" key={ 1 }>
					{ first }
				</div>,

				<div className="c-form-table__thead second" key={ 2 }>
					{ second }
				</div>
			];
		}
		else
		{
			t_head =
			(
				<div className="c-form-table__thead">
					{ head }
				</div>
			);
		}

		let output =
		(
			<div className="c-form-table" key={ key }>

				{ title }

				<div className="c-form-table__table">
					{ t_head }

					{ rows }
				</div>

				<button type="button"
					className="c-btn c-btn--extra-small c-btn--add c-form-table__add u-margin-right-15"
					onClick={ addRow }>
					Ajouter
				</button>

				<button type="button"
					className="c-btn c-btn--extra-small c-form-table__add"
					onClick={ dupplicateLastRow }>
					Dupliquer la dernière ligne
				</button>

			</div>
		);

		return output;

		function getRow (i)
		{
			let columns_count = Object.keys(table.columns).length;

			let hidden = false;

			if (table.hide_name)
			{
				let pattern = state.form_data.model +
					'[' + table.table_name + '][' + i +'][' + table.hide_name + ']';

				hidden = [true ,'true'].includes(state.form_data[pattern]);
			}

			if (table.show_hidden && hidden === true)
			{
				let pattern = state.form_data.model + '[' + table.show_hidden + ']';

				hidden = [true, 'true'].includes(state.form_data[pattern]) === false;
			}

			if (hidden === true) return null;

			let cells = Object.keys(table.columns).map(function (label, key)
			{
				let output;

				if (key === columns_count-1 && (table.break !== true || columns_count % 2 === 0))
				{
					output =
					(
						<div className="c-form-table__cell" key={ key }>
							<div className="c-form-table__cell-content">
								{ component.getFormElement(table.columns[label],
									null, false, i, table.table_name) }
								<button type="button"
									className="c-form-table__cell-delete c-btn c-btn--delete"
									onClick={ function (e) { removeRow(e, i); } }>
								</button>
							</div>
						</div>
					);
				}
				else
				{
					output =
					(
						<div className="c-form-table__cell" key={ key }>
							<div className="c-form-table__cell-content">
								{ component.getFormElement(table.columns[label],
									null, false, i, table.table_name) }
							</div>
						</div>
					);
				}

				return output;
			});

			let output;

			if (table.break === true)
			{
				let first  = cells
					.filter((cell, key) => key+1 <= (cells.length / 2 + cells.length % 2 ));

				let second = cells
					.filter((cell, key) => key+1 > (cells.length / 2 + cells.length % 2 ));

				if (first.length > second.length)
				{
					second.push(
						<div className="c-form-table__cell"
							key={ first.length + second.length }>
							<div className="c-form-table__cell-content">
								<button type="button"
									className="c-form-table__cell-delete c-btn c-btn--delete"
									onClick={ function (e) { removeRow(e, i); } }>
								</button>
							</div>
						</div>
					);
				}

				output =
				[
					<div className="c-form-table__row first" key={ ++row_key }>
						{ first }
					</div>,

					<div className="c-form-table__row second" key={ ++row_key + '_2' }>
						{ second }
					</div>
				];
			}
			else
			{
				output =
				(
					<div className="c-form-table__row" key={ ++row_key }>
						{ cells }
					</div>
				);
			}

			return output;
		}

		function addRow (e)
		{
			let repeatable_fields = component.state.repeatable_fields;

			repeatable_fields[table.table_name].count++;

			component.setState(
			{
				repeatable_fields: repeatable_fields
			});
		}

		function removeRow (e, number)
		{
			let repeatable_fields = component.state.repeatable_fields;
			let form_data = state.form_data;

			let count = repeatable_fields[table.table_name].count;

			repeatable_fields[table.table_name].count--;

			let form_name = config.model + '[' + table.table_name + ']';

		// Change form data to fill the gap let by the removed item
			if (number !== count-1)
			{
				for (let i = number; i < count-1; i++)
				{
					const replaced_pattern = form_name + '[' + i + '][';
					const next_row__pattern = form_name + '[' + (i+1) + '][';

				// delete all values from replaced row
					Object.keys(form_data)
					.filter(field => field.startsWith(replaced_pattern))
					.forEach(field => delete form_data[field]);

				// move all values from next row to replaced row
					Object.keys(form_data)
					.filter(field => field.startsWith(next_row__pattern))
					.forEach(function (field)
					{
						const replaced_field = field
						.replace(next_row__pattern, replaced_pattern);

						form_data[replaced_field] = form_data[field];
					});
				}
			}

			const last_row__pattern = form_name + '[' + (count-1) + '][';

		// delete all values from previously last row
			Object.keys(form_data)
			.filter(field => field.startsWith(last_row__pattern))
			.forEach(field => delete form_data[field]);

			component.setState(
			{
				repeatable_fields: repeatable_fields,
				form_data: form_data
			});
		}

		function dupplicateLastRow (e)
		{
			let repeatable_fields = component.state.repeatable_fields;
			let form_data = state.form_data;

			repeatable_fields[table.table_name].count++;

			let count = repeatable_fields[table.table_name].count;

			let columns = Object.keys(table.columns).slice(0);

			const not_duplicated = table.not_duplicated || [];

			columns.forEach(function (label, key)
			{
				let name = table.columns[label].split(table.table_name)[1];

				let form_name      = config.model + '[' + table.table_name + ']';
				let prev_line_name = form_name + '[' + (count-2) + ']' + name;

				form_name += '[' + (count-1) + ']' + name;

				if (['prices[ref]'].includes(table.columns[label]))
				{
					return;
				}
				else if (not_duplicated.includes(table.columns[label]))
				{
					return;
				}

				form_data[form_name] = form_data[prev_line_name];
			});

			component.setState(
			{
				repeatable_fields: repeatable_fields,
				form_data: form_data
			});
		}
	}

	handlePrivateChange (e, data)
	{
		const component = this, props = this.props;

		let private_form = this.state.private_form;

		if (data.display_name)
		{
			if (typeof data.data !== 'undefined' && data.data.id)
			{
				private_form[data.name] = data.data.id;
				private_form[data.display_name] = data.value;
			}
			else
			{
				private_form[data.name] = '';
				private_form[data.display_name] = data.value;
			}
		}
		else
		{
			if (private_form[data.name] === data.value)
			{
				return;
			}

			private_form[data.name] = data.value;
		}

		const update =
		{
			private_form: private_form
		};

		if (component.state.status_messages?.[data.name]?.error)
		{
			update.status_messages =
			{
				...component.state.status_messages,

				[data.name]: undefined
			};
		}

		component.setState(update);
	}

	removeViewItem (view, id)
	{
		const component = this, props = this.props, config = props.config;

		let form_data = { };

		let views = _.cloneDeep(component.state.views);

		let pattern = config.model;

		view.source_field.split('[').join(']').split(']')
		.filter(str => str !== '')
		.forEach(function (prop)
		{
			pattern += '[' + prop + ']';
		});

		Object.keys(component.state.form_data).forEach(function (field, index)
		{
			let value = component.state.form_data[field];

			if (field.indexOf(pattern) === -1)
			{
				if (value instanceof Array)
				{
					form_data[field] = value.slice();
				}
				else if (typeof value === 'object')
				{
					form_data[field] = _.cloneDeep(value);
				}
				else
				{
					form_data[field] = value;
				}
			}
		});

		let deleted_data = views[view.source_field].data.find(function (data, index)
		{
			if (data.model_data && data.model_data.id === id)
			{
				views[view.source_field].data.splice(index, 1);

				return true;
			}
		});

		if (typeof deleted_data === 'undefined')
		{
			views[view.source_field].data.find(function (data, index)
			{
				if (!data.model_data)
				{
					views[view.source_field].data.splice(index, 1);

					return true;
				}
			});
		}

		views[view.source_field].ids.find(function (element_id, index)
		{
			if (element_id === id)
			{
				views[view.source_field].ids.splice(index, 1);

				return true;
			}
		});

		views[view.source_field].ids.forEach(function (id, index)
		{
			let pattern = config.model;

			view.source_field.split('[').join(']').split(']')
			.filter(str => str !== '')
			.forEach(function (prop)
			{
				pattern += '[' + prop + ']';
			});

			pattern += '[' + index + ']';

			form_data[pattern] = id;
		});

		if (views[view.source_field].ids.length === 0)
		{
			form_data[config.model + '[' + view.source_field + ']'] = JSON.stringify([]);
		}

		if (config.hookOnViewChange instanceof Function)
		{
			config.hookOnViewChange.bind(component)(
			{
				view: view,
				id: id,
				type: 'removed'
			});
		}

		component.setState({ views: views, form_data: form_data });
	}

	get__Views ()
	{
		const component = this, props = this.props, config = this.props.config;
		const private_form = component.state.private_form;

		let views = (config.views || [])
		.filter(function (view, index)
		{
			if (view.show instanceof Function)
			{
				return view.show(component.state.form_data);
			}

			return true;
		})
		.map(function (view, index)
		{
			let field_infos = config.fields[view.source_field];

			let name = config.model, search = view.search || { };

			view.source_field.split('[').join(']').split(']')
			.filter(str => str !== '')
			.forEach(function (prop)
			{
				name += '[' + prop + ']';
			});

			let autocomplete_data = app.state.autocomplete_data[field_infos.reference.model];
			let autocomplete_value;

		// display name exists and there is no id for the field.
			if (typeof private_form['__display__' + name] !== 'undefined' &&
				!private_form[name])
			{
				autocomplete_value = private_form['__display__'+ name];
			}
			else
			{
				autocomplete_value = private_form[name];
			}

			let proposition = autocomplete_data.find(data => data.id === autocomplete_value);

			if (proposition)
			{
				if (typeof proposition.value === 'string')
				{
					autocomplete_value = proposition.value;
				}
				else if (proposition.value instanceof Object)
				{
					autocomplete_value = Object.keys(proposition.value)
					.reduce(function (final_value, prop)
					{
						if (search.display_fields instanceof Array === false)
						{
							if (final_value) final_value += ' ';

							final_value += proposition.value[prop];
						}
						else if (search.display_fields.indexOf(prop) !== -1)
						{
							if (final_value) final_value += ' ';

							final_value += proposition.value[prop];
						}

						return final_value;
					}, '');
				}
			}

			autocomplete_data = (autocomplete_data || []);

			let autocomplete =
			(
				<AutoCompletedField value={ autocomplete_value || '' }
					data={ autocomplete_data } label={ view.search_label }
					name={ name } id_prefix="creation-form-" referenced_value={ true }
					onChange={ component.handlePrivateChange }
					display_fields={ search.display_fields }
					readOnly={ component.state.readOnly || false } />
			);

			let view_elements = component.state.views[view.source_field].ids
			.map(function (id, key)
			{
				let loader;

				if (component.state.fetching_view_data === true)
				{
					loader = <Loader className="c-loader"
						bemit={ ['white', 'bg-primary', 'view-item'] } />;
				}

				let delete_btn =
				(
					<div className="u-text-right u-overflow-hidden">
						<button type="button" className="c-btn c-btn--delete c-btn--collapsible"
							onClick={ function (e) { component.removeViewItem(view, id); } }>
							Supprimer
						</button>
					</div>
				);

				let output = null;

				if (view.render instanceof Function)
				{
					let data = component.state.views[view.source_field].data
						.find(data => (data.model_data || { }).id === id);

					if (data)
					{
						output =
						(
							<div className="o-grid__item u-positioned" key={ id }>
								{ view.render(data, key) }

								{ delete_btn }
							</div>
						);

						if (loader)
						{
							output =
							(
								<div className="o-grid__item u-positioned" key={ id }>
									{ loader }
								</div>
							);
						}
					}
					else
					{
						output =
						(
							<div className="o-grid__item u-positioned" key={ id }>

								<div className="c-view-item">
									<div className="c-view-item__infos">
										<div className="c-view-item__data">
											Supprimé
										</div>
									</div>
								</div>

								{ delete_btn }
							</div>
						);
					}
				}

				return output;

			})
			.filter(value => value !== null);

			let style;

			if (Number.isInteger(view.order))
			{
				style =
				{
					order: view.order
				};
			}

			let output =
			(
				<div className={ 'c-form-view' +
					(component.state.status_messages[name]?.error
					? ' c-form-view--error' : '') } key={ index } style={ style }>

					<div className="c-title c-title--block">
						<h2 className="c-title__txt">{ view.title }</h2>
					</div>

					<div className="o-grid-2 c-form-view__search-area">

						<div className="o-grid__item">
							{ autocomplete }
						</div>

						<div className="o-grid__item">
							<button type="button" className={ 'c-btn c-btn--add' +
								(private_form[name] ? '' : ' disabled') }
								onClick={ function (e) { component.addViewElement(e, view); } }>
								{ view.add_label || 'Ajouter' }
							</button>
						</div>

					</div>

					<div className="c-form_view__items">
						<div className={ view.grid_class || 'o-grid-2' }>

							{ view_elements }

						</div>
					</div>

					{
						component.state.status_messages[name]?.error ?
						(
							<div className="c-field-error c-field-error--picker-view">
								{ component.state.status_messages[name].error }
							</div>
						)
						: undefined
					}

				</div>
			);

			return output;
		});

		return views ? views : undefined;
	}

	addViewElement (e, view)
	{
		const component = this, props = this.props, config = this.props.config;
		const state     = this.state;

		let private_form = component.state.private_form;

		let private_name = config.model;

		delete state.form_data[config.model + '[' + view.source_field + ']'];

		view.source_field.split('[').join(']').split(']')
		.filter(str => str !== '')
		.forEach(function (prop)
		{
			private_name += '[' + prop + ']';
		});

		let id = private_form[private_name];

		if (!id) return;

		private_form[private_name] = '';
		private_form['__display__' + private_name] = '';

		let duplicate = component.state.views[view.source_field].ids.find(view_id => view_id === id);

		if (!duplicate)
		{
			let views = _.cloneDeep(component.state.views);

			views[view.source_field].ids.unshift(id);

			let filter_query =
			{
				id: id
			};

			qwest.post('/CMS/getAll',
			{
				model: config.fields[view.source_field].reference.model,
				filter_query: JSON.stringify(filter_query)
			})
			.then(function (xhr, response)
			{
				let form_data = _.cloneDeep(component.state.form_data);
				let views     = _.cloneDeep(component.state.views);

				let data =
				{
					model_data: response.data[0],
					referenced_data: response.references
				};

				views[view.source_field].data.push(data);

				views[view.source_field].ids.forEach(function (id, index)
				{
					let pattern = config.model;

					view.source_field.split('[').join(']').split(']')
					.filter(str => str !== '')
					.forEach(function (prop)
					{
						pattern += '[' + prop + ']';
					});

					pattern += '[' + index + ']';

					form_data[pattern] = id;
				});

				component.setState(
				{
					views: views,
					fetching_view_data: false,
					form_data: form_data
				});
			})
			.catch(function (error, xhr, response)
			{
				component.setState(
				{
					fetching_view_data: false
				});

				app.ajaxRedirectLogin(response);

				console.error(error);
			});

			return component.setState(
			{
				private_form: private_form,
				views: views,
				fetching_view_data: true
			});
		}

		if (config.hookOnViewChange instanceof Function)
		{
			config.hookOnViewChange.bind(component)(
			{
				id: id,
				e: e,
				type: 'added'
			});
		}

		component.setState(
		{
			private_form: private_form,
			form_data: state.form_data
		});
	}

	componentDidMount ()
	{
		const component = this, props = this.props, state = this.state;

		if (props.config && props.config.hookOnUpdate instanceof Function)
		{
			props.config.hookOnUpdate.bind(component)();
		}
	}

	componentDidUpdate ()
	{
		const component = this, props = this.props, state = this.state;

		if (props.config && props.config.hookOnUpdate instanceof Function)
		{
			props.config.hookOnUpdate.bind(component)();
		}
	}

	render ()
	{
		const component = this, props = this.props, config = this.props.config;
		const state     = component.state;

		let output;

		let fields_to_render = Object.keys(config.fields);

		if (component.state.deleted)
		{
			output =
			(
				<div className="c-form">

					<div className="c-title c-title--form" style={ { order: -10000 } }>
						<h2 className="c-title__txt">{ config.form_title }</h2>
					</div>

					<div className="c-form-message c-form-message--green u-no-margin-bottom">
						<div className="c-form-message__content">
							Suppression réussie.
						</div>
					</div>

				</div>
			);

			return output;
		}

		const form_status =
		[
			{ label: 'info', suffix: '--green' },
			{ label: 'warning', suffix: '--orange' },
			{ label: 'error', suffix: '--red' },
			{ label: 'statement', suffix: '--blue' }
		];

		const loader = state.loading === true ?
		(
			<Loader className="c-loader" bemit={ ['white', 'bg-primary'] } />
		)
		: undefined;

		var submit =
		(
			<div className="c-btn-container c-btn-container--form">
				<button type="submit" className="c-btn c-btn--secondary c-btn--next"
					onClick={ function (e) { e.target.blur(); } }>
					Mettre à jour
					{ loader }
				</button>
			</div>
		);

		let views = component.get__Views();

		(config.views || []).forEach(function (view)
		{
		// Remove fields from the array of fields to render
			let field_index = fields_to_render.indexOf(view.source_field);

			if (field_index !== -1)
			{
				fields_to_render.splice(field_index, 1);
			}
		});

	/**
	 * Return all top-level collapses with their children (that can be collapses themselves)
	 **/
		var collapse_elements = (config.collapses || [])
		.filter(function (collapse, index)
		{
			if (collapse.show instanceof Function)
			{
				return collapse.show(component.state.form_data);
			}

			return true;
		})
		.map(function (collapse, key)
		{
		// Get elements inside the current collapse
			var elements = collapse.elements.map(get__Elements);

			let collapse_status = state.collapses_status[collapse.title];

			if (collapse_status)
			{
				collapse_status = form_status
				.filter(function (status_data)
				{
					return typeof collapse_status[status_data.label] !== 'undefined';
				})
				.map(function (status_data, index)
				{
					var message =
					(
						<div className="o-content" key={ index }>
							<div key={ index } className={ 'c-form-message ' +
								'c-form-message' + status_data.suffix }>
								<div className="c-form-message__content">
									{ state.collapses_status[collapse.title][status_data.label] }
								</div>
							</div>
						</div>
					);

					return message;
				});
			}

			let style;

			if (Number.isInteger(collapse.order))
			{
				style =
				{
					order: collapse.order
				};
			}

			var rendered_collapse =
			(
				<Collapse title={ collapse.title } key={ key } defaultsOpen={ collapse.open }
					className="c-collapse--form" style={ style }>

					<div className="o-grid-2">
						{ (elements.length > 0 ? elements : undefined) }
					</div>

					{ collapse_status }

				</Collapse>
			);

			return rendered_collapse;

		/**
		 * returns recursively a collapse's elements
		 *
		 * @param     { Array }    element    Array of elements (String / Object)
		 *
		 * @return    { ReactElement }        renderable React element
		 **/
			function get__Elements (element, key, depth_level)
			{
				var nested_collapse, elements, grid;
				var local_depth = typeof depth_level === 'number' ? depth_level : 0;

				if (typeof element === 'string')
				{
					if (!config.fields[element])
					{
						console.error('Unknown field : ', element);
					}

					if (config.fields[element].show instanceof Function)
					{
						if (!config.fields[element].show(component.state.form_data))
						{
							return null;
						}
					}

				// Remove fields from the array of fields to render
					let field_index = fields_to_render.indexOf(element);

					if (field_index !== -1)
					{
						fields_to_render.splice(field_index, 1);
					}

				// local_depth is used to strip out the grid if deepness is too great.
					return component.getFormElement(element, key, local_depth > 1 ? false : true);
				}
				else if (element instanceof Object && element.type === 'collapse')
				{
					if (element.show instanceof Function)
					{
						if (!element.show(component.state.form_data))
						{
							return null;
						}
					}

				// Get children recursively.
					elements = element.elements.map(function (collapse, key)
					{
						return get__Elements(collapse, key, (local_depth+1))
					});

				// Strips out the grid if deepness is too great.
					if (local_depth > 0)
					{
						grid = elements.length > 0 ? elements : undefined;
					}
					else
					{
						grid =
						(
							<div className="o-grid-2">
								{ (elements.length > 0 ? elements : undefined) }
							</div>
						);
					}

					let collapse_status = state.collapses_status[element.title];

					if (collapse_status)
					{
						collapse_status = form_status
						.filter(function (status_data)
						{
							return typeof collapse_status[status_data.label] !== 'undefined';
						})
						.map(function (status_data, index)
						{
							var message =
							(
								<div className="o-content" key={ index }>
									<div className={ 'c-form-message ' +
										'c-form-message' + status_data.suffix }>
										<div className="c-form-message__content">
											{ state.collapses_status[element.title][status_data.label] }
										</div>
									</div>
								</div>
							);

							return message;
						});
					}

					nested_collapse =
					(
						<Collapse title={ element.title } key={ key } defaultsOpen={ element.open }
							className="c-collapse--form">

							{ grid }

							{ collapse_status }

						</Collapse>
					);

					return nested_collapse;
				}
				else if (element instanceof Object && element.type === 'table')
				{
				// Remove table's fields from the array of fields to render
					Object.keys(element.columns).forEach(function (prop)
					{
						let field_index = fields_to_render.indexOf(element.columns[prop]);

						if (field_index !== -1)
						{
							fields_to_render.splice(field_index, 1);
						}
					});

					if (element.show instanceof Function)
					{
						if (!element.show(component.state.form_data))
						{
							return null;
						}
					}

					let table = component.get__Table(element, key);

					return table;
				}
			}
		});

		let custom_elements = (config.custom_fields || [])
		.map(function (element, index)
		{
			let count = component.state.repeatable_fields[element.name] || { };
				count = count.count || 0;

			let output;

			if (count > 1)
			{
				output = [];

				for (let i = 0; i < count; i++)
				{
					output.push
					(
						element.render(
						{
							onChange: component.handleChange,
							form_data: component.state.form_data,
							status_messages: component.state.status_messages,
							count: count,
							number: i,
							component: component
						})
					);
				}
			}

			return output || element.render(
			{
				onChange: component.handleChange,
				form_data: component.state.form_data,
				status_messages: component.state.status_messages,
				count: count,
				number: 0,
				component: component
			});
		});

		if (custom_elements[0])
		{
			custom_elements =
			(
				<div className="c-form-table">
					{ custom_elements }
				</div>
			);
		}

	/**
	 * Find all form elements found inside a { nested } collapse and
	 * map these elements to get a React element.
	 **/
		var form_elements = fields_to_render.filter(function (name)
		{
		// Allow hook to hide/show form elements based on form data.
			if (config.fields[name].show instanceof Function)
			{
				if (config.fields[name].show(component.state.form_data) !== true)
				{
					return false;
				}
			}

			var is__collapsed = false;

			is__collapsed = (config.collapses || []).find(function (collapse, key)
			{
				if (collapse.elements.indexOf(name) !== -1)
				{
					return true;
				}
				else
				{
					recursion(collapse.elements);

					return is__collapsed === true;
				}

			/**
			 * Recursion for nested collapses elements.
			 *
			 * @param    { Array }    elements    A collapse's elements
			 *
			 **/
				function recursion (elements)
				{
					if (is__collapsed === true) return;

					var find = elements.find(function (element, index)
					{
						if (name === element)
						{
							return true;
						}

						if (element instanceof Object && element.type === 'collapse')
						{
							recursion(element.elements);
						}
						else if (element instanceof Object && element.type === 'table')
						{
							recursion(Object.keys(element.columns)
								.map(label => element.columns[label])
							);
						}
					});

					if (find) is__collapsed = true;
				}
			}, false);

			return is__collapsed ? false : true;
		})
		.map(function (name, index)
		{
			return component.getFormElement(name, index);
		});

		let delete_btn =
		(
			<div className="u-text-right u-overflow-hidden">
				<button type="button" className="c-btn c-btn--delete c-btn--collapsible"
					onClick={ component.openDeleteModal }>
					Supprimer
				</button>
			</div>
		);

		if (component.state.readOnly === true)
		{
			delete_btn = undefined;
			submit     = undefined;
		}

		if (config.can_delete === false)
		{
			delete_btn = undefined;
		}

		let title =
		(
			<div className="c-title c-title--form">
				<h2 className="c-title__txt">
					{ config.formTitleHook instanceof Function ?
						config.formTitleHook(state.form_data) : config.form_title }
				</h2>
			</div>
		);

		if (props.hide_title === true)
		{
			title = undefined;
		}

		output =
		(
			<div className="u-positioned">

				<Form action="/CMS/update"
					data={ state.form_data } hide_button={ true }
					onValidate={ component.handleValidate }
					onError={ component.handleFailure }
					className={ props.className + ' c-form--update' }
					onSubmit={ function ()
					{
						component.setState({ loading: true });
					} }>

					{ title }

					{ props.children }

					{ collapse_elements }

					<div className="o-grid-2">

						{ form_elements }

					</div>

					{ views }

					{ custom_elements }

					{ getFormStatus(state) }

					{
						state.errors?.length > 0
						? state.errors.map(error => getFormStatus({ error },
							{ style: { marginTop: 5, marginBottom: 5 } })
						)
						: undefined
					}

					{ submit }

					{ loader}

				</Form>

				{ delete_btn }

			</div>
		);

		return output;
	}
}

export default UpdateForm;